import { Link, useParams } from 'react-router-dom';

import Button from '@modules/common/components/button';
import Container from '@modules/common/components/container';
import { useLogout } from '@lib/query/mutations/customer';

import logoBlack from './logo_black.svg';
import logoRed from './logo_red.svg';

export default function LoginNav({ isLoggedIn }: { isLoggedIn: boolean }) {
  const { countryCode } = useParams<{ countryCode: string }>();

  const logout = useLogout({
    onSuccess: () => {
      // Navigate to home after logout
      window.location.href = `/${countryCode ?? 'tw'}`;
    },
  });

  const handleLogout = () => {
    logout.mutate();
  };

  return (
    <div className="bg-white-10 group sticky inset-x-0 top-0 z-40">
      <header className="relative mx-auto bg-white duration-200">
        <nav className="h-full w-full">
          <Container className="flex h-[60px] items-center justify-between md:h-[180px] lg:h-[60px]">
            <Link
              to={`/${countryCode ?? 'tw'}`}
              className="txt-compact-xlarge-plus hover:text-ui-fg-base py-2 uppercase"
              data-testid="nav-store-link"
            >
              <img
                className="pharmhub-show mx-auto w-[128px] md:w-[166px]"
                src={logoRed}
                width={640}
                height={160}
                alt="logo"
              />
              <img
                className="medhub-show mx-auto w-[128px] md:w-[166px]"
                src={logoBlack}
                width={640}
                height={160}
                alt="logo"
              />
            </Link>
            {isLoggedIn && (
              <Button
                onClick={handleLogout}
                variant="outlined"
                className="text-base font-normal px-4"
                disabled={logout.isPending}
              >
                {logout.isPending ? '登出中...' : '會員登出'}
              </Button>
            )}
          </Container>
        </nav>
      </header>
    </div>
  );
}
